export default __webpack_public_path__ + "static/media/Jessica_Potts_AHV_In_Moms_We_Trust.c4612795.jpg";